import { render, staticRenderFns } from "./SoftwareDeveloper.vue?vue&type=template&id=091556ba&scoped=true&"
import script from "./SoftwareDeveloper.vue?vue&type=script&lang=js&"
export * from "./SoftwareDeveloper.vue?vue&type=script&lang=js&"
import style0 from "./SoftwareDeveloper.vue?vue&type=style&index=0&id=091556ba&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "091556ba",
  null
  
)

export default component.exports